// import PropTypes from "prop-types";
// import React from "react";
// import { Link } from "react-router-dom";
// import ParticleTwo from "../particles/ParticleTwo";

// const HeroSliderTwoSingle = ({ data }) => {
//   return (
//     <div
//       className="slide d-flex align__center poss--relative"
//       style={{
//         backgroundImage: `url(${
//           process.env.PUBLIC_URL + data.backgroundImage
//         })`,
//         backgroundRepeat: `no-repeat`,
//         backgroundSize: `cover`,
//       }}
//     >
//       <div className="container">
//         <div className="row">
//           <div className="col-lg-8 col-xl-7 col-md-12 col-sm-12 col-12 d-flex align-items-center">
//             <div className="slide__inner">
//               <h1>{data.title}</h1>
//               <p>{data.text}</p>
//               <Link
//                 className="slide__btn dg__btn btn--white btn--theme"
//                 to={process.env.PUBLIC_URL + data.url}
//               >
//                 Read More
//               </Link>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* particle */}
//       //{/* <ParticleTwo /> */}
//     </div>
//   );
// };

// HeroSliderTwoSingle.propTypes = {
//   data: PropTypes.object,
// };

// export default HeroSliderTwoSingle;

import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import ParticleTwo from "../particles/ParticleTwo";

const HeroSliderTwoSingle = ({ data }) => {
  return (
    <div className="slide d-flex align__center poss--relative hero-video-background">
      <video autoPlay loop muted className="hero-video">
        {/* <source
          src={process.env.PUBLIC_URL + "/videos/video.mp4"}
          type="video/mp4"
        /> */}
        <source
          src={process.env.PUBLIC_URL + "/videos/video_new.mp4"}
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
      <div className="video-overlay"></div>
      <div className="container poss--relative z-1">
        <div className="row justify-content-center">
          {" "}
          {/* ADDED: Centers the column block in the row */}
          <div className="col-lg-8 col-xl-7 col-md-12 col-sm-12 col-12 d-flex align-items-center">
            <div className="slide__inner text-center">
              {" "}
              {/* MODIFIED: Centers text inside the content block */}
              <h1>{data.title}</h1>
              <p>{data.text}</p>
            </div>
          </div>
          <div className=" text-center">
            <Link
              className="dg__btn btn--black btn--theme"
              to={process.env.PUBLIC_URL + data.url}
            >
              Register
            </Link>
          </div>
        </div>
      </div>
      {/* //<ParticleTwo /> */}
    </div>
  );
};

HeroSliderTwoSingle.propTypes = {
  data: PropTypes.object,
};

export default HeroSliderTwoSingle;
